import {Component} from '@angular/core';

@Component({
	selector: 'workflow-missing-value-icon',
	templateUrl: './missing-value-icon.component.html',
	styleUrls: ['./missing-value-icon.component.scss']
})
export class MissingValueIconComponent {

}
